"use client";

import { Logo } from "@/components/ui/logo";
import { useCallback } from "react";

export function LandingHeaderMobile() {
  const handleLogoClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    [],
  );

  return (
    <>
      <header className="flex items-center justify-between p-4 lg:hidden">
        <button onClick={handleLogoClick}>
          <Logo variant="small" colored font="nunitoSans" />
        </button>
      </header>
    </>
  );
}
